exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1ZWmy{position:absolute;top:10px;left:50px;z-index:1}._1CpWX{padding:8px 8px 8px 12px;background-color:#fff;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.1)}._10hvV{font-weight:400;margin:0 0 0 10px;word-wrap:break-word;font-size:12px;line-height:16px;letter-spacing:.2px;padding-top:0;padding-bottom:0;color:#484848}", ""]);

// exports
exports.locals = {
	"redoContainer": "_1ZWmy",
	"redoContent": "_1CpWX",
	"redoText": "_10hvV"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/SearchListing/RedoSearch/RedoSearch.css
// module id = 2570
// module chunks = 15